export default __webpack_public_path__ + "static/media/menu.a3f70a4d.svg";